var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.375C4.5 10.5065 6.067 8.99178 8 8.99178C9.933 8.99178 11.5 10.5065 11.5 12.375M3.625 15H12.375C13.8247 15 15 13.8247 15 12.375V3.625C15 2.17525 13.8247 1 12.375 1H3.625C2.17525 1 1 2.17525 1 3.625V12.375C1 13.8247 2.17525 15 3.625 15ZM10.1341 5.69762C10.1341 6.84229 9.17414 7.77023 7.98996 7.77023C6.80578 7.77023 5.84581 6.84229 5.84581 5.69762C5.84581 4.55294 6.80578 3.625 7.98996 3.625C9.17414 3.625 10.1341 4.55294 10.1341 5.69762Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRectangle);
export default __webpack_public_path__ + "static/media/userRectangle.86df94735a88c0c47c59df696961a811.svg";
export { ForwardRef as ReactComponent };